<template>
  <!-- 饼图展示 -->
  <div class="antv-chart-mini">
    <div class="chart-wrapper" :style="{ height: 46 }">
       <v-chart :force-fit="true"  :data="dataChart" :scale="scale" :padding="[36, 5, 18, 5]">
        <v-tooltip />
        <v-pie :position="position" />
      </v-chart>
    </div>
  </div>
</template>

<script>
const tooltip = [
  'x*y',
  (x, y) => ({
    name: x,
    value: y
  })
]

const scales = [{
  dataKey: 'x'
  // min: 2
}, {
  dataKey: 'y',
  title: '时间'
  // min: 1,
  // max: 30
}]

export default {
  name: 'MiniPie',
  props: {
    position: {
      type: String,
        default: 'x*y'
    },
    dataChart: {
      type: Array,
      default: function () {
        return []
      }
    },
    scale: {
      type: Array,
       default: function () {
        return scales
      }
    }
  },
  data () {
    return {

      tooltip,
      scales,
      height: 100,
    }
  }
}
</script>

<style lang="less" scoped>
  @import "chart";
</style>
